module.exports = __webpack_public_path__ + "img/cover-promotion-bg.3c9f1787.png";